import { defineMessages } from "react-intl";

const messages = defineMessages({
  emptyArea: {
    id: "map.territories.sidebar.create.footer.ok.tooltip.emptyAreas",
    defaultMessage: "Please select at least one area to create this territory.",
    description: "A tooltip shown over a Save button when territory is empty (no areas selected)",
  },
  emptyName: {
    id: "map.territories.sidebar.create.footer.ok.tooltip.emptyName",
    defaultMessage: "Please provide a name for this territory",
    description: "A tooltip shown over a Save button when territory name is empty",
  },
  nothingDrawn: {
    id: "map.territories.sidebar.create.footer.ok.tooltip.nothingDrawn",
    defaultMessage: "Please draw a shape on the map to create this territory.",
    description: "A tooltip shown over a Save button when territory is empty (nothing drawn)",
  },
});

export default messages;
